import { Record as ImRecord } from 'immutable';

import type { Tax, TaxInput, TaxInputProps, TaxProps } from './taxesTypes';
import { mkTax, mkTaxInput } from './taxesTypes';

export const transformTaxInputClientResourceToRequestData = (
  clientResource: TaxInput | TaxInputProps,
): TaxInputProps => (ImRecord.isRecord(clientResource) ? clientResource.toJS() : clientResource);

export const transformTaxInputServerResourceToClientResource = (serverResource: TaxInputProps): TaxInput =>
  mkTaxInput(serverResource);

export const transformServerResourceToClientResource = (serviceResource: TaxProps): Tax => mkTax(serviceResource);
